import { CalendarViewType } from 'types';

export const DISPLAY_DATE_FORMAT = `MM/DD/YYYY HH:mm`;
export const DISPLAY_DATE_REPORT_FORMAT = `MM-DD-YYYY HH:mm A`;
export const DISPLAY_DATE_12_HOUR_FORMAT = `MM/DD/YYYY h:mm:ss A`;
export const DETAILED_DISPLAY_DATE_FORMAT = `MM/DD/YYYY HH:mm:ss A`;
export const DATE_FORMAT = `MM/DD/YYYY`;
export const DATE_FORMAT_ISO = `YYYY/MM/DD`;
export const DATE_FORMAT_EVENT = `YYYY-MM-DDTHH:mm:ssZ`;
export const DATE_FORMAT_UTC = `YYYY-MM-DD`;
export const APEX_CHART_FORMAT = `MM/dd/yyyy HH:mm`;
export const DATE_RANGE_KEYS = {
  [CalendarViewType.WEEKLY]: 'week',
  [CalendarViewType.MONTHLY]: 'month',
  [CalendarViewType.YEARLY]: 'year',
} as const;
export const DISPLAY_24_DATE_FORMAT = `MM/DD/YYYY HH:mm:ss`;
export const DATE_FORMAT_ZONE_TIME_LOCAL_ZONE = 'YYYY-MM-DD HH:mm:ss';
export const LONG_DATE_TIME_FORMAT = 'L HH:mm:ss';
export const LOCALIZED_DATE_TIME_FORMAT = 'l HH:mm:ss';
export const LOCALIZED_DATE_TIME_ZONE_FORMAT = 'l HH:mm:ss z';
export const DATE_FORMAT_MONTHLY = 'MMM YYYY';
export const LT_TIME_FORMAT = 'LT';
